import { Liquid, type LiquidOptions } from 'liquidjs';

import currency from '../liquid-filters/currency';
import pluralize from '../liquid-filters/pluralize';

type TWaypointRendererOptions = {
  strict: boolean;
  outputEscape: boolean;
};
export default function createWaypointRenderer(options: TWaypointRendererOptions): Liquid {
  const liquidOptions: LiquidOptions = {};
  if (options.strict) {
    liquidOptions.strictFilters = true;
    liquidOptions.strictVariables = true;
    liquidOptions.lenientIf = true;
  } else {
    liquidOptions.strictFilters = false;
    liquidOptions.strictVariables = false;
  }

  if (options.outputEscape) {
    liquidOptions.outputEscape = 'escape';
  }

  const engine = new Liquid(liquidOptions);
  engine.registerFilter('currency', currency);
  engine.registerFilter('pluralize', pluralize);
  return engine;
}
